export default __webpack_public_path__ + "static/media/pethomerFacebook-1200x630.a64ae56f.png";